var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12587_104204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7497 13.0785H27.2497C27.4928 13.0785 27.7259 12.9819 27.8979 12.81C28.0698 12.6381 28.1663 12.4049 28.1663 12.1618C28.1663 11.9187 28.0698 11.6855 27.8979 11.5136C27.7259 11.3417 27.4928 11.2451 27.2497 11.2451H10.7497C10.5066 11.2451 10.2734 11.3417 10.1015 11.5136C9.92958 11.6855 9.83301 11.9187 9.83301 12.1618C9.83301 12.4049 9.92958 12.6381 10.1015 12.81C10.2734 12.9819 10.5066 13.0785 10.7497 13.0785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7497 18.5785H21.7497C21.9928 18.5785 22.2259 18.4819 22.3979 18.31C22.5698 18.1381 22.6663 17.9049 22.6663 17.6618C22.6663 17.4187 22.5698 17.1855 22.3979 17.0136C22.2259 16.8417 21.9928 16.7451 21.7497 16.7451H10.7497C10.5066 16.7451 10.2734 16.8417 10.1015 17.0136C9.92958 17.1855 9.83301 17.4187 9.83301 17.6618C9.83301 17.9049 9.92958 18.1381 10.1015 18.31C10.2734 18.4819 10.5066 18.5785 10.7497 18.5785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7497 24.0785H27.2497C27.4928 24.0785 27.7259 23.9819 27.8979 23.81C28.0698 23.6381 28.1663 23.4049 28.1663 23.1618C28.1663 22.9187 28.0698 22.6855 27.8979 22.5136C27.7259 22.3417 27.4928 22.2451 27.2497 22.2451H10.7497C10.5066 22.2451 10.2734 22.3417 10.1015 22.5136C9.92958 22.6855 9.83301 22.9187 9.83301 23.1618C9.83301 23.4049 9.92958 23.6381 10.1015 23.81C10.2734 23.9819 10.5066 24.0785 10.7497 24.0785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7497 29.5785H21.7497C21.9928 29.5785 22.2259 29.4819 22.3979 29.31C22.5698 29.1381 22.6663 28.9049 22.6663 28.6618C22.6663 28.4187 22.5698 28.1855 22.3979 28.0136C22.2259 27.8417 21.9928 27.7451 21.7497 27.7451H10.7497C10.5066 27.7451 10.2734 27.8417 10.1015 28.0136C9.92958 28.1855 9.83301 28.4187 9.83301 28.6618C9.83301 28.9049 9.92958 29.1381 10.1015 29.31C10.2734 29.4819 10.5066 29.5785 10.7497 29.5785Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12587_104204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 10.4116)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.34ab8c7c7934be75a2670cc3cc2e423b.svg";
export { ForwardRef as ReactComponent };